import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=ecb124c6&scoped=true"
import script from "./EditLink.vue?vue&type=script&lang=js"
export * from "./EditLink.vue?vue&type=script&lang=js"
import style0 from "./EditLink.vue?vue&type=style&index=0&id=ecb124c6&prod&scoped=true&lang=less"
import style1 from "./EditLink.vue?vue&type=style&index=1&id=ecb124c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb124c6",
  null
  
)

export default component.exports